<template>
  <div>
    <v-container>
      <v-text-field
        v-if="noSearch == null"
        v-model="search"
        solo
        label="Search"
        prepend-inner-icon="mdi-find-replace"
        clearable
      />
    </v-container>
    <div v-if="actions && actions.length > 0">
      <v-subheader
        v-if="title"
        :style="'color:' + $vuetify.theme.themes.light.primary"
        >{{ title.toUpperCase() }}</v-subheader
      >
      <v-subheader>{{ $tc("entities.action.title", 2) }}</v-subheader>
    </div>
    <v-subheader v-else>No Actions</v-subheader>
    <div v-for="(group, index) in actionsGroup" :key="index">
      <v-list subheader>
        <v-subheader
          v-if="group.group"
          dark
          :style="'color:' + $vuetify.theme.themes.light.primary"
          >{{ group.group }}</v-subheader
        >
        <div v-for="(action, index) in group.actions" :key="index">
          <v-list-item @click="clickItem(action)">
            <v-list-item-title>{{ action.description }}</v-list-item-title>
            <v-list-item-icon>
              <v-btn icon :loading="action.loading">
                <v-icon small>mdi-flash</v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>
        </div>
      </v-list>
      <v-divider v-if="group.actions && group.actions.length > 0"></v-divider>
    </div>

    <dialog-d
      v-model="dialogOpen"
      @cancel="dialogOpen = false"
      v-if="itemSelected"
      :title="itemSelected.description"
      @confirm="confirm"
      :loading="loading"
    >
      <div v-for="(item, index) in itemSelected.fields" :key="index">
        <action-field-auto-form
          :ref="index"
          :field="item"
          :confirm="confirm"
        ></action-field-auto-form>
      </div>
    </dialog-d>
    <action-response-content
      v-if="itemSelected"
      v-model="showResponse"
      :action="itemSelected"
      :response="response"
    ></action-response-content>
  </div>
</template>

<script>
import actionFieldAutoForm from "../forms/actions/actionFieldAutoForm";
import actionResponseContent from "./actionResponseContent";
export default {
  name: "actions-list",
  props: ["entity", "noSearch", "title", "data"],
  components: {
    actionFieldAutoForm,
    actionResponseContent,
  },

  data() {
    return {
      actions: [],
      actionsGroup: [],
      panel: [],
      search: "",
      loading: false,
      itemSelected: {},
      dialogOpen: false,
      response: null,
      showResponse: false,
    };
  },

  watch: {
    search() {
      this.actionsGroup = this.setupActions();
    },
  },

  methods: {
    sortAlph(a, b) {
      if (a < b) return -1;
      else if (a > b) return +1;
      else return 0;
    },
    createGroups() {
      let groups = [];
      groups.push(null);
      groups.push("");
      this.actions.forEach((a) => {
        if (groups.indexOf(a.group) < 0) groups.push(a.group);
      });

      let sort = groups.sort(this.sortAlph);

      return sort;
    },
    setupActions() {
      let actionsGroup = [];
      let groups = this.createGroups();

      groups.forEach((g) =>
        actionsGroup.push({
          group: g,
          actions: [],
        })
      );

      this.actions.forEach((a) => (a.loading = false));

      actionsGroup.forEach((ag) => {
        if (!this.search || this.search.lenght == 0) {
          ag.actions = this.actions
            .filter((a) => a.group == ag.group)
            .sort(this.sortAlph);
        } else {
          ag.actions = this.actions
            .filter(
              (a) =>
                a.group == ag.group &&
                a.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0
            )
            .sort(this.sortAlph);
        }
      });
      actionsGroup.forEach((ag, i) => {
        this.panel.push(i);
      });
      return actionsGroup;
    },
    async getActions() {
      let res = this.entity
        ? await this.$http.get(`action/entity-${this.entity}`)
        : await this.$http.get("action/separate");
      if (res.success) {
        this.actions = res.data;
        this.actionsGroup = this.setupActions();
      }
    },
    getValues() {
      let values = [];
      this.itemSelected.fields.forEach((item, index) => {
        let component = this.$refs[index.toString()][0];
        let fieldValue = component.getValue();
        values.push(fieldValue);
      });
      return values;
    },
    clearFields() {
      this.itemSelected.fields.forEach((item, index) => {
        let component = this.$refs[index.toString()][0];
        component.clear();
      });
    },
    fieldsValidate() {
      let valid = true;
      this.itemSelected.fields.forEach((item, index) => {
        let component = this.$refs[index.toString()][0];
        let isValid = component.validate();

        if (!isValid) valid = false;
      });
      return valid;
    },
    closeDialog() {
      //this.$refs.dialogFields.open(false);
      this.dialogOpen = false;
      this.clearFields();
    },
    async executeAction(fields) {
      this.loading = true;
      this.itemSelected.loading = true;
      let res = await this.$http.post(
        "action/execute?actionId=" + this.itemSelected.id,
        {
          fields,
          data: this.data,
        }
      );
      this.loading = false;
      this.itemSelected.loading = false;
      if (res.success) {
        this.dialogOpen = false;
        this.response = res.data.data;
        this.showResponse = true;
      } else {
        let errors = res.data.toString();
        await this.$confirm("error", errors);
      }
    },
    async confirm() {
      if (this.itemSelected.fields && this.itemSelected.fields.length > 0) {
        let fieldsValidate = this.fieldsValidate();
        console.log(fieldsValidate);
        if (!fieldsValidate) return;
        let fields = this.getValues();
        await this.executeAction(fields);
        this.closeDialog();
      }
    },
    resetItem() {
      this.showResponse = false;
      this.itemSelected = null;
      this.response = null;
    },
    async clickItem(item) {
      this.resetItem();
      this.itemSelected = item;
      if (item.fields && item.fields.length > 0) {
        this.dialogOpen = true;
        return;
      }

      await this.executeAction();
    },
  },
  async mounted() {
    await this.getActions();
  },
};
</script>
